var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWurfausgleich({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "20px",
    viewBox: "0 0 40 20",
    enableBackground: "new 0 0 40 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 40,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    d: "M29.792,8.359c-0.14,0-0.341-0.143-0.546-0.352c-0.234-0.238-0.617-0.636-1.193-1.556 c-0.536-0.856-0.987-1.829-2.016-2.76S24.179,2.833,23.9,2.712c-0.279-0.122-0.04-0.243-0.411-0.733 c-0.3-0.396-0.785-0.643-1.144-0.967C21.987,0.688,22.091,0,21.628,0c-0.462,0-0.126,2.205-0.568,1.851 c-0.363-0.291-1.344-1.446-1.583-1.446c-0.239,0-0.219,0.117-0.363,0.809c-0.143,0.692-0.235,2.514-0.235,2.514 s-0.837-0.292-2.49,0c-1.52,0.267-1.435,0.522-3.726,0.522S9.396,3.728,7.284,3.728c-1.167,0-2.459,0.595-3.364,1.516 C3.662,5.45,3.423,5.641,3.32,5.719c-0.269,0.205-1.143,0.752-1.322,0.82c-0.18,0.068-0.292,0.045-0.359-0.091 c-0.067-0.137-0.448-0.82-0.762-0.797s-0.56,0.25-0.516,0.524c0.045,0.273,0.35,0.566,0.527,0.652 c0.173,0.101,0.437,0.236,0.437,0.236S1.234,7.43,1.056,7.677C0.864,7.881,0.675,7.958,0.473,7.95 C0.277,7.943,0.209,7.897,0.204,7.896C0.115,7.87,0.025,7.908,0.005,7.983c-0.035,0.13,0.129,0.181,0.133,0.182 C0.193,8.188,0.442,8.284,0.72,8.224C0.943,8.175,1.325,7.905,1.437,7.7c0.112-0.205,0.247-0.478,0.247-0.615 c0-0.136,0.403-0.159,0.739-0.341c0.258-0.14,0.474-0.255,0.717-0.406C2.951,6.72,2.811,7.123,2.779,7.552 c-0.125,1.676,0.269,2.896,0.592,3.661c0.323,0.765,1.004,1.403,0.932,2.022c-0.071,0.618-0.18,1.814-0.143,2.521 c0.036,0.685,0.274,1.613,0.357,2.07c0.052,0.291,0.027,0.479,0.078,1.104c0.052,0.625,0.333,0.755,0.333,0.755l0.257-0.262 c0,0,0.518,0.548,1.05,0.574c0.532,0.026,1.04-0.234,0.847-0.521c-0.193-0.285-0.489-0.39-0.873-1.066 c-0.384-0.676-0.31-1.644-0.268-2.365c0,0-0.006-0.148,0.353-1.008c0.358-0.858,1.488-2.141,1.695-2.037 c0.207,0.104,2.611,0.754,5.07,0.754s3.586-0.352,3.893-0.324c0.308,0.028,1.896,1.625,2.101,2.303 c0.205,0.676,0.274,1.612,0.356,2.068c0.053,0.292,0.028,0.481,0.079,1.105c0.051,0.625,0.333,0.755,0.333,0.755l0.256-0.262 c0,0,0.518,0.548,1.05,0.573c0.532,0.026,1.041-0.233,0.848-0.52c-0.192-0.287-0.488-0.391-0.873-1.067 c-0.384-0.677-0.268-0.963-0.268-2.364c0-1.403,0.181-2.86,0.486-3.57c0.304-0.71,1.071-1.986,1.879-1.986 c0.807,0,1.873,0.585,4.218,0.501c1.183-0.042,1.38-0.531,1.882-1.211C29.801,9.077,30.29,8.359,29.792,8.359"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.65,
    strokeLinecap: "round",
    d: "M37.903,4.592 c0-2.455-1.462-3.767-3.265-3.767s-3.264,1.312-3.264,3.767"
  }), /*#__PURE__*/React.createElement("polyline", {
    clipPath: "url(#SVGID_2_)",
    points: "35.728,4.383 37.864,7.71 40,4.383  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWurfausgleich);
export default __webpack_public_path__ + "static/media/wurfausgleich.e68b32193b7368afa34d2da78f55f5ba.svg";
export { ForwardRef as ReactComponent };